export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?sca_esv=8f55d1c39308862b&rlz=1C1VDKB_frFR1090FR1090&sxsrf=APpeQntai6UG_DyJBt165-9AE8g7eaREdA:1789638530010&q=RB-espace-vert&si=APenkKmVGdgpMPDQZoEWS8RIAhsqXAKlNLP0B8DNkkiU9KPI0dGFWXzEyhgUpQ-9Sv-Znnp2Q3_QtzAxM0Uf7PgeDkreBhPM6SVbPiHJIlmf-bVBDBJGBJlP_PcaBExdWBdv0bI7basD&sa=X&ved=2ahUKEwjQ6-2Gq_WWAxVQVaQEHS7kKZIQ_coHegQIORAB&biw=1536&bih=756&dpr=1.25";

export const GOOGLE_RATING = "4,5";
export const GOOGLE_REVIEWS_COUNT = 17;
export const PHONE_DISPLAY = "06 03 69 83 46";
export const PHONE_TEL = "tel:+33603698346";
export const ADDRESS = "95 Av. du Président Wilson, 93100 Montreuil";
export const GOOGLE_WRITE_REVIEW_URL =
  "https://www.google.com/maps/place/RB-espace-vert/data=!4m2!3m1!1s0x0:0x9f18ef71507e9332";
